import { PRIMARY } from '../../../styles';

export default {
  container: {
    padding: 10,
  },
  body: {
    margin: 10,
  },
  row: {
    paddingTop: 15,
    paddingBottom: 15,
    // marginBottom: 30,
    verticalAlign: 'middle',
    borderBottom: '1px solid lightgray',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 10,
    width: 280,
  },
  costEstimator: {
    padding: 20,
  },
  slider: {
    flex: 1,
    marginTop: 10,
    marginBottom: 10,
    paddingTop: 10,
    paddingBottom: 10,
  },
  cost: {
    textAlign: 'right',
    fontSize: 36,
    color: PRIMARY,
  },
  count: {
    textAlign: 'right',
    fontSize: 24,
    color: PRIMARY,
  },
  retentionPeriod: {
    textAlign: 'right',
    fontSize: 24,
    color: PRIMARY,
  },
  retentionPeriodCost: {
    textAlign: 'right',
    fontSize: 36,
    color: PRIMARY,
  },
  brandedApp: {
    flex: 1,
    fontSize: '1.17em',
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  brandedAppCost: {
    textAlign: 'right',
    fontSize: 36,
    color: PRIMARY,
  },

  heading: {
    marginBottom: 3,
    marginTop:0,
  },
  item: {
    margin: 'auto',
  },
  switch: {
    textAlign: 'right',
  }
};



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/UpgradeDialog/styles.js